module.exports = __webpack_public_path__ + "static/media/map11.44845816.webp";